import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: center;
  font-family: "Poppins";
  margin:0;
  h1{
  font-weight: 700;
  font-size: 20px;
  margin:0;
  }
  p{
  font-weight: 300;
  font-size: 13.5px;
  margin:0;
  }
  .row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    }
  form {
    padding: 0.75rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    width: 100%;
  }
`;
